var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTable",
        {
          staticClass: "unit-settings-translation-table",
          attrs: { isCheckable: false }
        },
        [
          _c(
            "CompassTableHead",
            [
              _c("CompassTableHeadCell"),
              _vm._v(" "),
              _c("CompassTableHeadCell", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t.__("common.labels.value")) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "SaasDraggable",
            {
              attrs: {
                dragClass: "unit-settings-table__row",
                isTable: true,
                disabled: !_vm.editMode,
                handle: ".unit-settings-translation-table__drag-handle"
              },
              on: { input: _vm.handleSortUpdate },
              model: {
                value: _vm.localUnits,
                callback: function($$v) {
                  _vm.localUnits = $$v
                },
                expression: "localUnits"
              }
            },
            _vm._l(_vm.units, function(unitItem) {
              return _c(
                "CompassTableRow",
                { key: unitItem.id, staticClass: "unit-settings-table__row" },
                [
                  _c(
                    "CompassTableBodyCell",
                    {
                      staticClass:
                        "unit-settings-translation-table__drag-column",
                      attrs: { width: 64 }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "unit-settings-translation-table__drag-handle"
                        },
                        [
                          _c("CompassIcon", {
                            attrs: {
                              icon: "drag-and-drop",
                              type: _vm.isEditable ? "primary" : "disabled"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("CompassTableBodyCell", { attrs: { width: 220 } }, [
                    !_vm.editMode
                      ? _c(
                          "span",
                          {
                            class: {
                              "typographies-paragraph-medium-regular": true,
                              "unit-settings-translation-table__value--is-default": _vm.isDefaultValue(
                                unitItem
                              )
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getTranslatedValue(unitItem).value) +
                                "\n                    "
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass:
                              "unit-settings-translation-table__value-wrapper"
                          },
                          [
                            _c("CompassInput", {
                              model: {
                                value: _vm.getTranslation(unitItem).value,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.getTranslation(unitItem),
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "getTranslation(unitItem).value"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "unit-settings-translation-table__value-default typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.$t.__("common.labels.default")) +
                                    " : " +
                                    _vm._s(unitItem.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          ],
                          1
                        )
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.editMode
        ? _c("AddUnitRow", { on: { addUnit: _vm.addUnit } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }